.li {
    align-items: flex-start;
    border-bottom: 1px solid var(--gray-300);
    color: var(--black);
    cursor: pointer;
    display: flex;
    gap: var(--spacer-8);
    isolation: isolate;
    padding: var(--spacer-24);
    position: relative;

    &:last-child {
        border-bottom: none;
    }

    address {
        font-style: normal;
    }
}

.focused {
    background-color: var(--beige);
}

.contactInfo {
    flex: 1;
    min-width: 0;
}

.clickable {
    width: 100%;
    text-align: left;
}

.locationName {
    font: var(--font-h-24);
}

.showroomName {
    font: var(--font-h-24);
    letter-spacing: 0.24px;
}

.glyph {
    display: flex;
    justify-content: center;
    position: relative;
    width: 22px;
    aspect-ratio: 22 / 32;
    padding-top: 6px;
    font: var(--font-p-12);
    letter-spacing: 0.36px;
    color: var(--white);
    flex-shrink: 0;
}

.markerGlyph {
    font-size: 12px;
}

.pin {
    position: absolute;
    inset: 0;
    fill: var(--gray-500);
    z-index: -1;
}

.technicureanPin {
    composes: pin;
    fill: var(--red);
}

.itemWithIcon {
    display: flex;
    gap: var(--spacer-8);
    margin-block: var(--spacer-8);
    font: var(--font-p-14);
}

.svg {
    width: 18px;
    height: 18px;
    fill: var(--black);
    flex-shrink: 0;
}

.external {
    composes: svg;
    width: 14px;
    height: 14px;
}

.textLink {
    font: var(--font-text-link-12);
    color: inherit;
    text-decoration: underline;
    text-underline-offset: 0.1875em;
}

.text {
    color: var(--black);
    font: var(--font-p-14);
    font-weight: 400;
    text-decoration: none;
}

.distance {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: var(--spacer-4);
    font: var(--font-p-14);
    color: var(--black);
    flex-shrink: 0;
}
